export default () => import(/* webpackChunkName: "myAuthority" */ './myAuthority')
